import { useCallback } from "react";

export const useBadge = ({ onClick }) => {
  const onBadgeClick = useCallback(() => {
    if (typeof onClick === "function") {
      onClick();
    }
  }, [onClick]);
  return {
    onBadgeClick,
  };
};
